(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsListController', ReportsListController);

    ReportsListController.$inject = ['common', 'dataservice'];
    /* @ngInject */
    function ReportsListController(common, dataservice) {
        var vm = this;
        vm.title = 'Reports';
        vm.opsIncludeVersion = common.opsIncludeVersion;
       

        activate();

        function activate() {
            var promises = [];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }
    }
})();
